import {Box, Button} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

export default function UploadImg({base64Image, setBase64Image, maxSize}: any) {
  const {t} = useTranslation()

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (!file) return
    console.log(maxSize, file.size, 'file size')

    if (maxSize && file.size / 10 > maxSize) {
      alert(`The image is too large. Maximum size allowed is ${maxSize / 1000}MB.`)
      return
    }

    // Convert image to base64
    const reader = new FileReader()
    reader.onloadend = () => {
      setBase64Image(file)
    }
    reader.readAsDataURL(file)
  }

  return (
    <Box>
      <Button
        sx={{
          color: 'red',
          padding: '13px 21px',
          background: 'rgba(216, 25, 35, 0.1)',
          borderRadius: '7px',
          marginTop: '10px',
        }}
        component='label'
      >
        {t('uploadImage')}
        <input hidden accept='image/*' onChange={handleImageChange} type='file' />
      </Button>
    </Box>
  )
}
